import { render, staticRenderFns } from "./ChannelModal.vue?vue&type=template&id=6855afd2&"
import script from "./ChannelModal.vue?vue&type=script&lang=js&"
export * from "./ChannelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports